/* Ott-common */
import { createAEMService } from '@dtvgo/aem-service';

export default createAEMService({ host: window.location.origin });
